<template>
  <div class="rightForward">
    <ul>
      <li v-for="(item,ind) in standardData"
          :key="ind"
          @click="showLight(ind)"
          :class="light == ind?'light':''">
        <ul>
          <li class="rightForwardLi"><span>{{item.stanardByAppNameData?item.stanardByAppNameData:'无'}}</span></li>
          <li class="rightForwardLi"><span>接收人:{{item.toUserName}}</span></li>
          <li class="rightForwardLi"><span>时间:{{item.createTime?item.createTime:''}}</span></li>
        </ul>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'rightForward',
  props: {
    contentId: Array,
    name: Number
  },
  data () {
    return {
      standardData: [],
      light: 0,
      contentIds: ''
    }
  },
  mounted () {
    if (this.contentId && this.contentId[0] && this.contentId[0][0] && this.contentId[0][0].contentId) {
      this.contentIds = this.contentId[0][0].contentId;
    }
    if (this.name == parseInt(this.getQuery('dataType'))) {
      this.show();
    }
  },
  methods: {
    showLight (ind) {
      this.light = ind;
    },
    show () {
      this.$http
        .get('/zciid-deliverable/interface/deliverables/meetData/list.json', {
          appId: this.getQuery('appId'),
          blockId: '',
          contentId: this.contentIds
        })
        .then(res => {
          this.standardData = res.data;
        })
    }
  }
}
</script>
<style scoped>
.light {
  border: 1px solid #0c78cf !important;
}
.rightForward {
  padding: 12px 0 20px 12px;
  border-left: 1px solid #ddd;
  overflow-x: hidden;
  overflow-y: auto;
  position: absolute;
  top: 0;
  left: 1019px;
  height: 100%;
  box-sizing: border-box;
}
.rightForward > ul {
  width: 145px;
}
.rightForward > ul > li {
  border: 1px solid #ddd;
  margin-top: 8px;
}
.rightForwardLi:first-child {
  font-size: 18px;
  color: #333;
  font-weight: 500;
  height: 28px;
  line-height: 28px;
  margin: 0 5px;
  overflow: hidden;
}
.rightForwardLi {
  font-size: 14px;
  color: #666;
  line-height: 24px;
  margin: 0 5px;
}
@media screen   and (max-width: 768px) {
  .rightForward {
    position: unset !important;
    border-left: none !important;
  }
  .rightForward > ul {
    width: calc(100% - 12px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newFlowDetail/rightForward.vue